var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "well ovx-auto" },
    [
      _c("div", { staticClass: "flex-level" }, [
        _c("div", { staticClass: "flex fs-4 bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Notes de frais")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex aright" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.impact_profit"),
                type: "secondary",
                disabled: _vm.impactButtonIsDisable
              },
              on: {
                click: function($event) {
                  return _vm.impact()
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "documents.overview.tab.margin.Expense.link_an_expense"
                ),
                type: "secondary",
                disabled: !_vm.canImpact,
                onclick:
                  "expensesTools.linkTo('" +
                  _vm.doctype +
                  "', " +
                  _vm.docid +
                  ");"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.expenses },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              selectable: _vm.canProcess,
              property: "processMargin"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.impact_profit") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.displaySaasBoolean(scope.row.processMargin)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$filters.saasDateFormatted(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "supplier",
              label: _vm.$t.__("documents.overview.tab.margin.supplier")
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "ident",
              label: _vm.$t.__("common.labels.reference")
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "formatted_totalAmount",
              label: _vm.$t.__(
                "documents.overview.tab.margin.purchase_amount_exclude_tax"
              )
            }
          }),
          _vm._v(" "),
          _vm.canImpact
            ? _c("el-table-column", {
                attrs: { fixed: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "link mr-2",
                              on: {
                                click: function($event) {
                                  return _vm.removeLink(scope.row, _vm.context)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$l10n.__("Délier")) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3847650210
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.expenses.length > 0
        ? _c("div", { staticClass: "aright fs-3 mt-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$filters.numberFormatCurrency(
                    _vm.$l10n.__("Total impact")
                  ) +
                    " : " +
                    _vm._s(_vm.formattedTotal)
                ) +
                "\n    "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }